import { MODALS } from 'common/domain/constants';

class DelegatedCardListMobileController {

  constructor($timeout, EventEmitter) {
    'ngInject';
    this.timeout = $timeout;
    this.EventEmitter = EventEmitter;
    this.employeeModal = undefined;
  }

  get delegatedRequestModal() {
    return $(MODALS.DELEGATED_REQUEST_MODAL);
  }

  onProcessEmployee({ employee }) {
    this.openModalDelegatedRequest(employee);
  }

  updateEmployees($event) {
    let event = this.EventEmitter($event);
    this.updateDataEmployees(event);
  }

  openModalDelegatedRequest(employee) {
    this.employeeModal = employee;
    this.timeout(() => {
      this.delegatedRequestModal.modal('show');
    });
  }

}

export default DelegatedCardListMobileController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardListMobile.controller.js